/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { FancyAction } from 'src/app/common/fancy-firebase/base/FancyAction';

import { FancyActionableFirebase } from 'src/app/common/fancy-firebase/generics/FancyActionableFirebase';

import { LaborCountList } from 'src/app/common/fancy-firebase/services/factories';
import { LaborCount } from 'src/app/app-data/models/LaborCount';

export class LaborCounts extends FancyActionableFirebase<LaborCount, FancyAction, LaborCountList> {
	constructor(public data: LaborCountList) {
		super(data);
	}
}
